import { render } from "./PatientLoginScreen.vue?vue&type=template&id=51e3ba67"
import script from "./PatientLoginScreen.vue?vue&type=script&lang=js"
export * from "./PatientLoginScreen.vue?vue&type=script&lang=js"

import "./PatientLoginScreen.vue?vue&type=style&index=0&id=51e3ba67&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__